/**
 * @generated SignedSource<<ced80fc6cf3a65aae98ea01f80f86a3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LibraryHooksWatchChannelMutation$variables = {
  channelId: string;
  value: boolean;
};
export type LibraryHooksWatchChannelMutation$data = {
  readonly channelSetWatching: {
    readonly channel: {
      readonly id: string;
      readonly viewerWatching: boolean | null;
    };
  } | null;
};
export type LibraryHooksWatchChannelMutation$rawResponse = {
  readonly channelSetWatching: {
    readonly channel: {
      readonly id: string;
      readonly viewerWatching: boolean | null;
    };
  } | null;
};
export type LibraryHooksWatchChannelMutation = {
  rawResponse: LibraryHooksWatchChannelMutation$rawResponse;
  response: LibraryHooksWatchChannelMutation$data;
  variables: LibraryHooksWatchChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channelId",
        "variableName": "channelId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "ChannelSetWatching",
    "kind": "LinkedField",
    "name": "channelSetWatching",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Channel",
        "kind": "LinkedField",
        "name": "channel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerWatching",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryHooksWatchChannelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LibraryHooksWatchChannelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a44b3d1bf1ed2174017113bb2a2e9dbc",
    "id": null,
    "metadata": {},
    "name": "LibraryHooksWatchChannelMutation",
    "operationKind": "mutation",
    "text": "mutation LibraryHooksWatchChannelMutation(\n  $channelId: ID!\n  $value: Boolean!\n) {\n  channelSetWatching(channelId: $channelId, value: $value) {\n    channel {\n      id\n      viewerWatching\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "04f56fd6c89cdaad90f0dd63dd95648a";

export default node;
